import React, { useState, useContext, useEffect } from "react";
import { ListGroup, Accordion, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWheelchair, faChevronLeft, faLocationPin } from '@fortawesome/free-solid-svg-icons';
import { renderToString } from 'react-dom/server';
import L from 'leaflet';

import { useBreakpoints } from "../hooks";
import './providerDetail.css';
import { DevContext } from "../context";
import { ProviderDto, VaccineDto, ProviderAuxiliaryDataDto } from "../../models";

import API from "../../lib/devApi";
import moment from "moment";

export default function ProviderDetail(props: any) {
    const breakpoint = useBreakpoints();
    const { selectedProvider, setSelectedProvider, setShowLoading, providerAuxiliaryData, setProviderAuxiliaryData, mapContext } = useContext(DevContext);

    const [listDetailHeight, setListDetailHeight] = useState(window.innerHeight);
    // const [providerAuxiliaryData, setProviderAuxiliaryData] = useState<ProviderAuxiliaryDataDto>();

    const customIcon = <FontAwesomeIcon icon={faLocationPin} fontSize={52} />
    const selectedIcon = <FontAwesomeIcon icon={faLocationPin} style={{color: "gray !important"}} fontSize={36} />

    const divIcon = L.divIcon({
        html: renderToString(customIcon),
        iconSize: [30, 42],
        iconAnchor: [15, 42],
        className: "icon-bg"
    })

    const divSelectedIcon = L.divIcon({
        html: renderToString(selectedIcon),
        iconSize: [30, 42],
        iconAnchor: [15, 42],
        className: "icon-bg"
    })

    let _listDetailStyle = {};
    switch(breakpoint) {
        case "xs":
        case "sm":
        case "md":
            _listDetailStyle = {height: listDetailHeight, backgroundColor: "white"};
            break;
        case "lg":
        case "xl":
        case "xxl":
            _listDetailStyle = {};
            break;
    }

    const [listDetailStyle, setListDetailStyle] = useState(_listDetailStyle);

    // useEffect(() => {
        // if(selectedProvider) {
        //     (async () => {
        //         // console.log(selectedProvider);
        //         try {
        //             setShowLoading(true);
        //             const result = await API.GetProviderAuxiliaryData(selectedProvider.providerId);
        //             setProviderAuxiliaryData(result);
        //         } catch (error) {
                    
        //         }
        //         finally {
        //             setShowLoading(false);
        //         }

        //     })();
        // }

    // }, [selectedProvider])


    const renderOrganizationDetails = (selectedProvider: ProviderDto) => {
        let result: React.ReactNode;
        if(selectedProvider.healthCenterTypeId != null) {
            result = (
                <>{selectedProvider.healthCenterName}</>
            );
        }
        else if(selectedProvider.medicalPracticeTypeId != null) {
            result = (
                <>{selectedProvider.medicalPracticeName}</>
            );
        }
        else if(selectedProvider.farmacyTypeId != null) {
            result = (
                <>{selectedProvider.farmacyName}</>
            );
        }
        else if(selectedProvider.publicHealthProviderTypeId != null) {
            result = (
                <>{selectedProvider.publicHealthProviderName}</>
            );
        }
        else if(selectedProvider.longTermCareTypeId != null) {
            result = (
                <>{selectedProvider.longTermCareName}</>
            );
        }
        else {
            result = (
                <>{selectedProvider.otherOrganization}</>
            );
        }

        return result;
    }

    return (
        <React.Fragment>
            {selectedProvider?
                <div>
                    <div className="detail-header-container">
                        <div>
                            <Button onClick={() => {
                                setProviderAuxiliaryData(undefined);
                                setSelectedProvider(undefined);
                            }} variant="see-more"><FontAwesomeIcon icon={faChevronLeft} /> &nbsp;Atras</Button>
                        </div>
                    </div>
                    <div className="detail-container" style={listDetailStyle}>
                        <div className="detail-item">
                                <div>
                                    <h2 style={{margin: 0}}>{selectedProvider.name}</h2>
                                    {/* {selectedProvider?.isOpen?
                                        <span style={{color: "green", fontWeight: 700}}>Abierto para vacunación contra el COVID-19</span>
                                        : <span style={{color: "red", fontWeight: 700}}>Cerrado para vacunación contra el COVID-19</span>
                                    } */}
                                </div>

                                <br />
                                <div>
                                    <p>{selectedProvider.address}<br></br><a target="_blank" href={`https://www.google.com/maps/search/?api=1&query=${selectedProvider.latitude}%2C${selectedProvider.longitude}`}>Ver Dirección en Google Maps.</a></p>
                                </div>
                                
                                <div>
                                    <a href={`tel:+1${selectedProvider.phone.replace(" ", "").replace("(", "").replace(")", "").replace("-", "")}`}>{selectedProvider.phone}</a>
                                    {selectedProvider.ext && selectedProvider.ext != ""? <p>Ext {selectedProvider.ext}</p>: <br />}
                                </div>

                                <div>
                                    {selectedProvider.altPhone && selectedProvider.altPhone != ""? <a href={`tel:+1${selectedProvider.altPhone.replace(" ", "").replace("(", "").replace(")", "").replace("-", "")}`}>{selectedProvider.altPhone}</a>: <></>}
                                    {selectedProvider.altExt && selectedProvider.altExt != ""? <p>Ext {selectedProvider.altExt}</p>: <br />}
                                </div>
                                
                                <div>
                                    {selectedProvider.email && selectedProvider.email !=""? <p>{selectedProvider.email}</p> : <br />}
                                </div>

                                <br />

                                <div>
                                    <h5>Estacionamiento disponible: {providerAuxiliaryData && providerAuxiliaryData.hasParking? "Sí" : "No"}</h5>
                                    {
                                        providerAuxiliaryData && providerAuxiliaryData.hasParking? selectedProvider.parkingHasCost? <p>Estacionamiento es libre de costo.</p> : <p>Estacionamiento tiene costo.</p> : <></>
                                    }
                                </div>

                                <br />

                                {
                                        providerAuxiliaryData && providerAuxiliaryData.accessibilityCriteria && providerAuxiliaryData.accessibilityCriteria.length > 0?
                                        <>
                                        {/* <FontAwesomeIcon icon={faWheelchair} fontSize={24} style={{backgroundColor: "blue", color: "white", padding: 5, borderRadius: 5}} /> */}
                                            <h5>Accessibilidad <FontAwesomeIcon icon={faWheelchair} color="blue" /></h5>
                                            <ListGroup variant="flush">
                                                {providerAuxiliaryData.accessibilityCriteria.map((method: string, idx: number) => {
                                                    return <ListGroup.Item key={idx}>{method}</ListGroup.Item>
                                                })}
                                                {
                                                    selectedProvider.otherAccessibilityCriteria && selectedProvider.otherAccessibilityCriteria != ""? 
                                                    <ListGroup.Item key={99}>{selectedProvider.otherAccessibilityCriteria}</ListGroup.Item>
                                                    : <></>
                                                }
                                            </ListGroup>
                                        </>
                                        : <></>
                                    }

                                <br />

                                <div>
                                    <h5>Organizaci&oacute;n:</h5>
                                    <p>{selectedProvider.organizationName}:&nbsp;{renderOrganizationDetails(selectedProvider)}</p>
                                </div>

                                <Accordion defaultActiveKey="1">
                                    {/* <Accordion.Item eventKey="0">
                                        <Accordion.Header>
                                        <h5>Horario para vacunaci&oacute;n de COVID-19</h5>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <ListGroup variant="flush">
                                                <ListGroup.Item>
                                                    <Row>
                                                        <Col>
                                                            <span style={{fontWeight: 700}}>Domingo</span>:
                                                        </Col>
                                                        <Col sm={6}>
                                                            <span>{selectedProvider.schedule.sundayStart? moment(selectedProvider.schedule.sundayStart).format("hh:mm A") : "Cerrado"}
                                                            -
                                                            {selectedProvider.schedule.sundayEnd? moment(selectedProvider.schedule.sundayEnd).format("hh:mm A") : "Cerrado"}</span>
                                                        </Col>
                                                    </Row>
                                                </ListGroup.Item>
                                                <ListGroup.Item>
                                                    <Row>
                                                        <Col>
                                                            <span style={{fontWeight: 700}}>Lunes</span>:
                                                        </Col>
                                                        <Col sm={6}>
                                                            <span>{selectedProvider.schedule.mondayStart? moment(selectedProvider.schedule.mondayStart).format("hh:mm A") : "Cerrado"}
                                                            -
                                                            {selectedProvider.schedule.mondayEnd? moment(selectedProvider.schedule.mondayEnd).format("hh:mm A") : "Cerrado"}</span>
                                                        </Col>
                                                    </Row>
                                                </ListGroup.Item>
                                                <ListGroup.Item>
                                                    <Row>
                                                        <Col>
                                                            <span style={{fontWeight: 700}}>Martes</span>:
                                                        </Col>
                                                        <Col sm={6}>
                                                            <span>{selectedProvider.schedule.tuesdayStart? moment(selectedProvider.schedule.tuesdayStart).format("hh:mm A") : "Cerrado"}
                                                            -
                                                            {selectedProvider.schedule.tuesdayEnd? moment(selectedProvider.schedule.tuesdayEnd).format("hh:mm A") : "Cerrado"}</span>
                                                        </Col>
                                                    </Row>
                                                </ListGroup.Item>
                                                <ListGroup.Item>
                                                    <Row>
                                                        <Col>
                                                            <span style={{fontWeight: 700}}>Mi&eacute;rcoles</span>:
                                                        </Col>
                                                        <Col sm={6}>
                                                            <span>{selectedProvider.schedule.wednesdayStart? moment(selectedProvider.schedule.wednesdayStart).format("hh:mm A") : "Cerrado"}
                                                            -
                                                            {selectedProvider.schedule.wednesdayEnd? moment(selectedProvider.schedule.wednesdayEnd).format("hh:mm A") : "Cerrado"}</span>
                                                        </Col>
                                                    </Row>
                                                </ListGroup.Item>
                                                <ListGroup.Item>
                                                    <Row>
                                                        <Col>
                                                            <span style={{fontWeight: 700}}>Jueves</span>:
                                                        </Col>
                                                        <Col sm={6}>
                                                            <span>{selectedProvider.schedule.thursdayStart? moment(selectedProvider.schedule.thursdayStart).format("hh:mm A") : "Cerrado"}
                                                            -
                                                            {selectedProvider.schedule.thursdayEnd? moment(selectedProvider.schedule.thursdayEnd).format("hh:mm A") : "Cerrado"}</span>
                                                        </Col>
                                                    </Row>
                                                </ListGroup.Item>
                                                <ListGroup.Item>
                                                    <Row>
                                                        <Col>
                                                            <span style={{fontWeight: 700}}>Viernes</span>:
                                                        </Col>
                                                        <Col sm={6}>
                                                            <span>{selectedProvider.schedule.fridayStart? moment(selectedProvider.schedule.fridayStart).format("hh:mm A") : "Cerrado"}
                                                            -
                                                            {selectedProvider.schedule.fridayEnd? moment(selectedProvider.schedule.fridayEnd).format("hh:mm A") : "Cerrado"}</span>
                                                        </Col>
                                                    </Row>
                                                </ListGroup.Item>
                                                <ListGroup.Item>
                                                    <Row>
                                                        <Col>
                                                            <span style={{fontWeight: 700}}>S&aacute;bado</span>:
                                                        </Col>
                                                        <Col sm={6}>
                                                            <span>{selectedProvider.schedule.saturdayStart? moment(selectedProvider.schedule.saturdayStart).format("hh:mm A") : "Cerrado"}
                                                            -
                                                            {selectedProvider.schedule.saturdayEnd? moment(selectedProvider.schedule.saturdayEnd).format("hh:mm A") : "Cerrado"}</span>
                                                        </Col>
                                                    </Row>
                                                </ListGroup.Item>
                                                {
                                                    selectedProvider.schedule.breakTime?
                                                        <ListGroup.Item>
                                                            <Row>
                                                                <Col>
                                                                    <span style={{fontWeight: 700}}>Horario de Break</span>:
                                                                </Col>
                                                                <Col sm={6}>
                                                                    {selectedProvider.schedule.breakTime}
                                                                </Col>
                                                            </Row>
                                                        </ListGroup.Item>
                                                        :<></>
                                                }
                                            </ListGroup>
                                        </Accordion.Body>
                                    </Accordion.Item> */}

                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header>
                                        <h5>Vacunas disponibles:</h5>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <ListGroup variant="flush">
                                                {selectedProvider.vaccines.map((vaccine: VaccineDto, idx: number) => {
                                                    return <ListGroup.Item key={idx}>{vaccine.name}</ListGroup.Item>
                                                })}
                                                {
                                                    selectedProvider.otherVaccine? 
                                                    <ListGroup.Item key={99}>{selectedProvider.otherVaccine}</ListGroup.Item>
                                                    : <></>
                                                }
                                            </ListGroup>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    {
                                        providerAuxiliaryData && providerAuxiliaryData.appointmentCoordinationMethods && providerAuxiliaryData.appointmentCoordinationMethods.length > 0?
                                        <Accordion.Item eventKey="2">
                                            <Accordion.Header>
                                                <h5>Metodos para coordinación de cita</h5>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <ListGroup variant="flush">
                                                    {providerAuxiliaryData.appointmentCoordinationMethods.map((method: string, idx: number) => {
                                                        return <ListGroup.Item key={idx}>{method}</ListGroup.Item>
                                                    })}
                                                    {
                                                        selectedProvider.otherCoordinationMethod && selectedProvider.otherCoordinationMethod != ""? 
                                                        <ListGroup.Item key={99}>{selectedProvider.otherCoordinationMethod}</ListGroup.Item>
                                                        : <></>
                                                    }
                                                </ListGroup>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        : <></>
                                    }


                                    {
                                        providerAuxiliaryData && providerAuxiliaryData.additionalServices && providerAuxiliaryData.additionalServices.length > 0?
                                        <Accordion.Item eventKey="3">
                                            <Accordion.Header>
                                                <h5>Servicios adicionales</h5>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <ListGroup variant="flush">
                                                    {providerAuxiliaryData.additionalServices.map((method: string, idx: number) => {
                                                        return <ListGroup.Item key={idx}>{method}</ListGroup.Item>
                                                    })}
                                                    {
                                                        selectedProvider.otherAdditionalService && selectedProvider.otherAdditionalService != ""? 
                                                        <ListGroup.Item key={99}>{selectedProvider.otherAdditionalService}</ListGroup.Item>
                                                        : <></>
                                                    }
                                                </ListGroup>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    : <></>
                                    }


                                    {
                                        providerAuxiliaryData && providerAuxiliaryData.populations && providerAuxiliaryData.populations.length > 0?
                                        <Accordion.Item eventKey="4">
                                            <Accordion.Header>
                                                <h5>Poblaciones Atendidas</h5>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <ListGroup variant="flush">
                                                    {providerAuxiliaryData.populations.map((method: string, idx: number) => {
                                                        return <ListGroup.Item key={idx}>{method}</ListGroup.Item>
                                                    })}
                                                </ListGroup>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        : <></>
                                    }
                                    
                                    {/* {
                                        providerAuxiliaryData && providerAuxiliaryData.accessibilityCriteria && providerAuxiliaryData.accessibilityCriteria.length > 0?
                                        <Accordion.Item eventKey="5">
                                            <Accordion.Header>
                                                <h5>Criterios de Accessibilidad</h5>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <ListGroup variant="flush">
                                                    {providerAuxiliaryData.accessibilityCriteria.map((method: string, idx: number) => {
                                                        return <ListGroup.Item key={idx}>{method}</ListGroup.Item>
                                                    })}
                                                    {
                                                        selectedProvider.otherAccessibilityCriteria && selectedProvider.otherAccessibilityCriteria != ""? 
                                                        <ListGroup.Item key={99}>{selectedProvider.otherAccessibilityCriteria}</ListGroup.Item>
                                                        : <></>
                                                    }
                                                </ListGroup>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        : <></>
                                    } */}
                                    
                                    {
                                        providerAuxiliaryData && providerAuxiliaryData.serviceLangs && providerAuxiliaryData.serviceLangs.length > 0?
                                        <Accordion.Item eventKey="6">
                                            <Accordion.Header>
                                                <h5>Lenguajes de Servicio</h5>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <ListGroup variant="flush">
                                                    {providerAuxiliaryData.serviceLangs.map((method: string, idx: number) => {
                                                        return <ListGroup.Item key={idx}>{method}</ListGroup.Item>
                                                    })}
                                                    {
                                                        selectedProvider.otherServiceLanguage && selectedProvider.otherServiceLanguage != ""? 
                                                        <ListGroup.Item key={99}>{selectedProvider.otherServiceLanguage}</ListGroup.Item>
                                                        : <></>
                                                    }
                                                </ListGroup>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        : <></>
                                    }
                                    
                                </Accordion>
                                <br />

                            </div>
                    </div>
                </div>
                :<></>
            }
        </React.Fragment>
    )
}